import { MAIN_ADDRESS_TYPE_ID } from "@/config/config"

const hasCoordinates = address => address?.location?.coordinates?.length === 2

/**
 * Adresse, die für einen Betrieb angezeigt wird (Karte und Detail):
 * Hauptadresse, sonst die erste andere Adresse (z. B. Rechnungsadresse) mit Koordinaten.
 * Die API liefert nur öffentliche Adressen.
 */
export function getDisplayAddress(company) {
    const addresses = company?.addresses ?? []
    return addresses.find(a => a.addresstypeid === MAIN_ADDRESS_TYPE_ID)
        ?? addresses.find(hasCoordinates)
        ?? addresses[0]
        ?? null
}

export function getCoordinates(company) {
    const address = getDisplayAddress(company)
    return hasCoordinates(address) ? address.location.coordinates : null
}
